import { __extends } from "tslib";
import { Info } from './Info';
var ClassInfo = /** @class */ (function (_super) {
    __extends(ClassInfo, _super);
    function ClassInfo(abc, instanceInfo, initializer, traits) {
        var _this = _super.call(this) || this;
        _this.abc = abc;
        _this.instanceInfo = instanceInfo;
        _this.initializer = initializer;
        _this.traits = traits;
        _this.trait = null;
        _this.runtimeTraits = null;
        return _this;
    }
    ClassInfo.prototype.getNativeMetadata = function () {
        if (!this.trait) {
            return null;
        }
        var metadata = this.trait.getMetadata();
        if (!metadata) {
            return null;
        }
        for (var i = 0; i < metadata.length; i++) {
            if (metadata[i].getName() === 'native') {
                return metadata[i];
            }
        }
        return null;
    };
    ClassInfo.prototype.getInitializer = function () {
        if (typeof this.initializer === 'number') {
            this.initializer = this.abc.getMethodInfo(this.initializer);
            this.initializer.classInfo = this;
        }
        return this.initializer;
    };
    ClassInfo.prototype.toString = function () {
        return 'ClassInfo ' + this.instanceInfo.getName();
    };
    ClassInfo.prototype.trace = function (writer) {
        writer.enter('ClassInfo');
        this.traits.trace(writer);
        writer.outdent();
    };
    return ClassInfo;
}(Info));
export { ClassInfo };
